/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Preview_PdfInputs */

const en_preview_pdf = /** @type {(inputs: Preview_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preview PDF`)
};

const es_preview_pdf = /** @type {(inputs: Preview_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vista Previa PDF`)
};

const fr_preview_pdf = /** @type {(inputs: Preview_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aperçu PDF`)
};

const de_preview_pdf = /** @type {(inputs: Preview_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF-Vorschau`)
};

const ja_preview_pdf = /** @type {(inputs: Preview_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDFをプレビュー`)
};

const zh_preview_pdf = /** @type {(inputs: Preview_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`预览 PDF`)
};

const ar_preview_pdf = /** @type {(inputs: Preview_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`معاينة PDF`)
};

const id_preview_pdf = /** @type {(inputs: Preview_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pratinjau PDF`)
};

const it_preview_pdf = /** @type {(inputs: Preview_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anteprima PDF`)
};

const ru_preview_pdf = /** @type {(inputs: Preview_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предпросмотр PDF`)
};

const pt_preview_pdf = /** @type {(inputs: Preview_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pré-visualizar PDF`)
};

const ko_preview_pdf = /** @type {(inputs: Preview_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF 미리보기`)
};

/**
* | output |
* | --- |
* | "Preview PDF" |
*
* @param {Preview_PdfInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const preview_pdf = /** @type {((inputs?: Preview_PdfInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preview_PdfInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_preview_pdf(inputs)
	if (locale === "es") return es_preview_pdf(inputs)
	if (locale === "fr") return fr_preview_pdf(inputs)
	if (locale === "de") return de_preview_pdf(inputs)
	if (locale === "ja") return ja_preview_pdf(inputs)
	if (locale === "zh") return zh_preview_pdf(inputs)
	if (locale === "ar") return ar_preview_pdf(inputs)
	if (locale === "id") return id_preview_pdf(inputs)
	if (locale === "it") return it_preview_pdf(inputs)
	if (locale === "ru") return ru_preview_pdf(inputs)
	if (locale === "pt") return pt_preview_pdf(inputs)
	return ko_preview_pdf(inputs)
});